import React, {Component} from "react";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import Layout from "../../containers/Layout";
import OrdersOutput from "../../containers/OrdersOutput";

class OrdersPage extends Component {
    render() {
        return (
            <Layout>
                <Title>Активные заказы</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Активные заказы', url: '/orders'}
                ]}/>
                <OrdersOutput/>
            </Layout>
        );
    }
}

export default OrdersPage
